import axios from 'axios'

export default {
  namespaced: true,
  state: {
    exercises: [],
    loading: false
  },
  mutations: {
    loading(state, value) {
      state.loading = value
    },
    exercises(state, value) {
      state.exercises = value
    }
  },
  actions: {
    fetchLessonExercises({commit, state}, {lessonId}) {
      return new Promise((resolve, reject) => {
        commit('loading', true)
        axios.get('/lesson/exercises/' + lessonId)
          .then((response) => {
            commit('exercises', response.data)
            resolve(response.data)
          })
          .catch((error) => {
            reject(error)
          })
          .finally(() => {
            commit('loading', false)
          })
      })
    },
    fetchExercise({commit, state}, {id}) {
      return axios.get('/lesson/exercise/' + id)
        .then(({data}) => {
          return Promise.resolve(data)
        })

    }
  },
  getters: {
    exercises: state => state.exercises,
    loading: state => state.loading
  }
}
